export class PartsForSaleStatuses {
    public static Available : number = 1;
    public static Sold : number      = 2;
    public static Refunded : number  = 3;
    public static Shipped : number   = 4;
    public static Completed : number = 4;
    public static Expired : number   = 5;
    public static Canceled : number  = 6;
}